import * as React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import GenericHeader from '../components/headers/GenericHeader';
import Colors from '../constants/Colors';
import WalletStackNavigator from '../navigation/WalletNavigator';

export default function WalletScreen() {
  return (
    <View style={styles.container}>
      <WalletStackNavigator />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  }
});
